import { TestComponent } from './core/component/test/test.component';
import { DocmeetfarmerComponent } from './core/component/docmeetfarmer/docmeetfarmer.component';
import { ResulttsupportterComponent } from './core/component/resulttsupportter/resulttsupportter.component';
import { GrouprepairComponent } from './core/component/grouprepair/grouprepair.component';
import { ReportbynotifyComponent } from './core/component/reportbynotify/reportbynotify.component';
import { DoccheckfarmerComponent } from './core/component/doccheckfarmer/doccheckfarmer.component';
import { ViewsupportterComponent } from './core/component/viewsupportter/viewsupportter.component';
import { AskforbanknumberComponent } from './core/component/askforbanknumber/askforbanknumber.component';
import { PrintbarcodeComponent } from './core/component/printbarcode/printbarcode.component';
import { CaneperzonebygroupComponent } from './core/component/caneperzonebygroup/caneperzonebygroup.component';
import { SugarcaneperhourComponent } from './core/component/sugarcaneperhour/sugarcaneperhour.component';
import { QueueandarearComponent } from './core/component/queueandarear/queueandarear.component';
import { CaneinperdayComponent } from './core/component/caneinperday/caneinperday.component';
import { CanepergroupbycutcarComponent } from './core/component/canepergroupbycutcar/canepergroupbycutcar.component';
import { EditplantcaneinComponent } from './core/component/editplantcanein/editplantcanein.component';
import { FindfarmerdataComponent } from './core/component/findfarmerdata/findfarmerdata.component';
import { AddcutcanetypeComponent } from './core/component/addcutcanetype/addcutcanetype.component';
import { CheckqueuezoneComponent } from './core/component/checkqueuezone/checkqueuezone.component';
import { BorrowqueueComponent } from './core/component/borrowqueue/borrowqueue.component';
import { FindcaneinstoreComponent } from './core/component/findcaneinstore/findcaneinstore.component';
import { AcceptbarcodeComponent } from './core/component/acceptbarcode/acceptbarcode.component';
import { CheckqueueonlineComponent } from './core/component/checkqueueonline/checkqueueonline.component';
import { EditplantinfoManagerComponent } from './core/component/editplantinfo-manager/editplantinfo-manager.component';
import { EditplantinfoComponent } from './core/component/editplantinfo/editplantinfo.component';
import { AskforbarcodeComponent } from './core/component/askforbarcode/askforbarcode.component';
import { CutrunningComponent } from './core/component/cutrunning/cutrunning.component';
import { ListhitoryformoneyComponent } from './core/component/listhitoryformoney/listhitoryformoney.component';
import { Season6465dataComponent } from './core/component/season6465data/season6465data.component';
import { Seasone6465Component } from './core/component/seasone6465/seasone6465.component';
import { ListaskformoneyheaderComponent } from './core/component/listaskformoneyheader/listaskformoneyheader.component';
import { FarmerreportComponent } from './core/component/farmerreport/farmerreport.component';

import { PrintaskformoneyComponent } from './core/component/printaskformoney/printaskformoney.component';
import { DocfertilizerComponent } from './core/component/docfertilizer/docfertilizer.component';
import { PrintfertilizerComponent } from './core/component/printfertilizer/printfertilizer.component';
import { AskforfactorComponent } from './core/component/askforfactor/askforfactor.component';
import { AskforfertilizerComponent } from './core/component/askforfertilizer/askforfertilizer.component';
import { DocforaskformoneyComponent } from './core/component/docforaskformoney/docforaskformoney.component';
import { AskformoneyComponent } from './core/component/askformoney/askformoney.component';
import { DocforcreditComponent } from './core/component/docforcredit/docforcredit.component';
import { RaindropComponent } from './core/component/raindrop/raindrop.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule, ActivatedRoute } from '@angular/router';

import { LoginComponent } from './login/login.component';

import { SupporterComponent } from './supporter/supporter.component';
import { ActionComponent } from './core/component/action/action.component';
import { KpiallComponent } from './core/component/kpiall/kpiall.component';
import { FindlanddataComponent } from './core/component/findlanddata/findlanddata.component';
import { AcceptComponent } from './core/component/accept/accept.component';
import { MyprofileComponent } from './core/component/myprofile/myprofile.component';
import { RepairgroupComponent } from './core/component/repairgroup/repairgroup.component';
import { StockonlineComponent } from './core/component/stockonline/stockonline.component';
import { PlantactionComponent } from './core/component/plantaction/plantaction.component';
import { PrbrdComponent } from './core/component/prbrd/prbrd.component';
import { GroupcutComponent } from './core/component/groupcut/groupcut.component';
import { CreditComponent } from './core/component/credit/credit.component';
import { ManageareaComponent } from './core/component/managearea/managearea.component';
import { DocforgroupcutComponent } from './core/component/docforgroupcut/docforgroupcut.component';
import { ReportplantcutComponent } from './core/component/reportplantcut/reportplantcut.component';
import { FinanceComponent } from './finance/finance.component';
import { ListacceptbyheaderComponent } from './core/component/listacceptbyheader/listacceptbyheader.component';
import { CanpergroupComponent } from './core/component/canpergroup/canpergroup.component';
import { RainfallComponent } from './core/component/rainfall/rainfall.component';
import { DashboardkpiComponent } from './core/component/dashboardkpi/dashboardkpi.component';
import { BugandgermComponent } from './core/component/bugandgerm/bugandgerm.component';
import { EditcaneinplantComponent } from './core/component/editcaneinplant/editcaneinplant.component';
import { EditplotComponent } from './core/component/editplot/editplot.component';
import { AuditListComponent } from './core/component/audit-list/audit-list.component';
import { GetFert3Component } from './core/component/get-fert3/get-fert3.component';
import { EditplotManagerComponent } from './core/component/editplot-manager/editplot-manager.component';
import { EditplotPartComponent } from './core/component/editplot-part/editplot-part.component';
import { EditplotPartFormComponent } from './core/component/editplot-part-form/editplot-part-form.component';
import { EmployeeComponent } from './core/component/employee/employee.component';
import { ExecutiveComponent } from './core/component/dashboard/executive/executive.component';
import { CpMapComponent } from './core/component/map/cp-map/cp-map.component';
import { Askforfactor6667Component } from './core/component/askforfactor6667/askforfactor6667.component';
import { Askformoney6667Component } from './core/component/askformoney6667/askformoney6667.component';
import { AnalysisPlanComponent } from './core/component/analysis-plan/analysis-plan.component';
import { InforQcardComponent } from './core/component/infor-qcard/infor-qcard.component';
import { DpsListComponent } from './core/component/deposit/dps-list/dps-list.component';
import { DpsEditComponent } from './core/component/deposit/dps-edit/dps-edit.component';
import { DpsDetailComponent } from './core/component/deposit/dps-detail/dps-detail.component';
import { OilpayComponent } from './core/component/oilpay/oilpay.component';
import { CarcutReportComponent } from './core/component/carcut-report/carcut-report.component';
import { ReportDismanAreaLvComponent } from './core/component/report-disman-area-lv/report-disman-area-lv.component';
import { SumDataCutComponent } from './core/component/sum-data-cut/sum-data-cut.component';
import { FarmerDevSysComponent } from './core/component/farmer-dev-sys/farmer-dev-sys.component';
import { FinanceOfdataComponent } from './core/component/finance-ofdata/finance-ofdata.component';
import { FileExcelComponent } from './core/component/file-excel/file-excel.component';
import { MoveOnQComponent } from './core/component/move-on-q/move-on-q.component';
import { FinanceListComponent } from './core/component/finance-list/finance-list.component';
import { FarmerAssessmentComponent } from './core/component/farmer-assessment/farmer-assessment.component';
import { ListKpiComponent } from './core/component/list-kpi/list-kpi.component';
import { ListKpiZoneComponent } from './core/component/list-kpi-zone/list-kpi-zone.component';

import { OkayGetFert3Component } from './core/component/okay-get-fert3/okay-get-fert3.component';
import { ForTestComponent } from './core/component/for-test/for-test.component';
import { KmlGeneratorComponent } from './core/component/kml-generator/kml-generator.component';
import { NewsComponent } from './core/component/news/news.component';
import { NewsEditComponent } from './core/component/news-edit/news-edit.component';
import { UpfileComponent } from './core/component/upfile/upfile.component';
import { Askforfactor67Component } from './core/component/askforfactor67/askforfactor67.component';
import { Askformoney67Component } from './core/component/askformoney67/askformoney67.component';
import { Docforaskformoney67Component } from './core/component/docforaskformoney67/docforaskformoney67.component';
import { Listaskformoney67Component } from './core/component/listaskformoney67/listaskformoney67.component';
import { NewInformComponent } from './core/component/new-inform/new-inform.component';
import { CaneYardComponent } from './core/component/cane-yard/cane-yard.component';
import { FileFinanceComponent } from './core/component/file-finance/file-finance.component';
import { DashboardCutFComponent } from './core/component/dashboard/dashboard-cut-f/dashboard-cut-f.component';
import { DashboardGrowedFComponent } from './core/component/dashboard-growed-f/dashboard-growed-f.component';
import { PrintReportCutFComponent } from './core/component/print-report-cut-f/print-report-cut-f.component';
import { Sidebar2Component } from './supporter/sidebar2/sidebar2.component';
import { BrdprojectComponent } from './core/component/brdproject/brdproject.component';
import { ProjectMemberComponent } from './core/component/project-member/project-member.component';
//import { CallbackComponent } from './core/callback/callback.component';
import { AuthGuardService } from './core/services/auth-guard.service';
import { Askformoney68Component } from './core/component/askformoney68/askformoney68.component';
import { Askforfactor68Component } from './core/component/askforfactor68/askforfactor68.component';
import { Listaskformoney68Component } from './core/component/listaskformoney68/listaskformoney68.component';
import { BrdDiaryCPCComponent } from './core/component/report/brd-diary-cpc/brd-diary-cpc.component';
import { SugarcaneQualityComponent } from './core/component/sugarcane-quality/sugarcane-quality.component';
import { SupervisDiaryCpcComponent } from './core/component/report/supervis-diary-cpc/supervis-diary-cpc.component';
import { FollowWorkComponent } from './core/component/follow-work/follow-work.component';
import { BrdCpcFormComponent } from './core/component/report/brd-cpc-form/brd-cpc-form.component';
import { CanequalityComponent } from './core/component/canequality/canequality.component';
import { PrintFarmersComponent } from './core/component/print-farmers/print-farmers.component';
import { EditGetfactorComponent } from './core/component/edit-getfactor/edit-getfactor.component';
import { MapGroupcodeComponent } from './core/component/map-groupcode/map-groupcode.component';

const routes: Routes = [

  { path: 'accept', component: AcceptComponent },
  { path: 'acceptbarcode', component: AcceptbarcodeComponent },
  { path: 'addcutcanetype', component: AddcutcanetypeComponent },
  { path: 'actionplant', component: ActionComponent },
  { path: 'askforbarcode', component: AskforbarcodeComponent },
  {
    path: 'askfactor', children: [
      //{ path: '6566', component: AskforfactorComponent },
      //{ path: '6667', component: Askforfactor6667Component },
      //{ path: '6768', component: Askforfactor67Component },
      { path: '6869', component: Askforfactor68Component },
    ]
  },
  {
    path: 'askformoney', children: [
      //{ path: '6566', component: AskformoneyComponent },
      //{ path: '6667', component: Askformoney6667Component },
      //{ path: '6768', component: Askformoney67Component },
      { path: '6869', component: Askformoney68Component },
    ]
  },
  { path: 'askforfertilizer', component: AskforfertilizerComponent },
  { path: 'borrowQueue', component: BorrowqueueComponent },
  { path: 'bangkokbank', component: AskforbanknumberComponent },
  { path: 'bugandgerm', component: BugandgermComponent },
  { path: 'CaneinPerday', component: CaneinperdayComponent },
  { path: 'canpergroup', component: CanpergroupComponent },
  { path: 'caneinbycutcar', component: CanepergroupbycutcarComponent },
  { path: 'caneinorderbyzone', component: CaneperzonebygroupComponent },
  { path: 'checkqueueonline', component: CheckqueueonlineComponent },
  { path: 'credit/:year', component: CreditComponent },
  { path: 'cutrunning', component: CutrunningComponent },
  { path: 'dashboardkpi', component: DashboardkpiComponent },
  { path: 'dashboard-brd', component: ExecutiveComponent },
  { path: 'doccheckfarmer', component: DoccheckfarmerComponent },
  { path: 'docfertilizer/:year/:fmcode/:doc_id/:status', component: DocfertilizerComponent },
  { path: 'docforaskformoney', component: DocforaskformoneyComponent },
  { path: 'docforaskformoney2/:year', component: Docforaskformoney67Component },
  { path: 'docforcredit/:year', component: DocforcreditComponent },
  { path: 'docforgroupcut', component: DocforgroupcutComponent },
  { path: 'docmeetfarmer', component: DocmeetfarmerComponent },
  { path: 'editplantcanein', component: EditplantcaneinComponent },
  { path: 'editcaneinplant', component: EditcaneinplantComponent },
  { path: 'editplantinfor', component: EditplantinfoComponent },
  { path: 'editplant_manager', component: EditplantinfoManagerComponent },
  { path: 'Editcutandrepair', component: GrouprepairComponent },
  { path: 'FarmerReport', component: FarmerreportComponent },
  { path: 'findcaneinstore', component: FindcaneinstoreComponent },
  { path: 'findfarmerdata', component: FindfarmerdataComponent },
  { path: 'findlanddata', component: FindlanddataComponent },
  { path: 'groupcut', component: GroupcutComponent },
  { path: 'historyaskformoney', component: ListhitoryformoneyComponent },
  { path: 'kpiall/:id', component: KpiallComponent },
  { path: 'AnalysisPlan', component: AnalysisPlanComponent },
  /*
    { path: 'listaskformoney', component: ListaskformoneyComponent },
    { path: 'listaskformoney66', component: Listaskformoney6667Component },
    { path: 'listaskformoney67', component: Listaskformoney67Component },
  */
  {
    path: 'listaskformoney', children: [
      //{ path: '6768', component: Listaskformoney67Component },
      { path: '6869', component: Listaskformoney68Component },
    ]
  },
  { path: 'listacceptbyHEADER', component: ListacceptbyheaderComponent },
  { path: 'listaskHeader', component: ListaskformoneyheaderComponent },
  { path: 'login', component: LoginComponent },
  { path: 'managearea', component: ManageareaComponent },
  { path: 'myprofile', component: MyprofileComponent },
  { path: 'plantaction', component: PlantactionComponent },
  { path: 'prbrd', component: PrbrdComponent },
  { path: 'printaskformoney', component: PrintaskformoneyComponent },
  { path: 'printbarcode/:truck_q1/:truck_q2', component: PrintbarcodeComponent },
  { path: 'printfertilizer/:year', component: PrintfertilizerComponent },
  { path: 'QueuebyZone', component: CheckqueuezoneComponent },
  { path: 'QueueAndArear', component: QueueandarearComponent },
  { path: 'rainfall', component: RaindropComponent },
  { path: 'raindrop', component: RainfallComponent },
  { path: 'repairgroup', component: RepairgroupComponent },
  { path: 'reportplant/:grouptype', component: ReportplantcutComponent },
  { path: 'reportnotify', component: ReportbynotifyComponent },
  { path: 'resultsupportter', component: ResulttsupportterComponent },
  { path: 'season6465', component: Seasone6465Component },
  { path: 'season6465data', component: Season6465dataComponent },
  { path: 'stockonline', component: StockonlineComponent },
  { path: 'supporter', component: SupporterComponent },
  { path: 'SugarCaneperhour', component: SugarcaneperhourComponent },
  { path: 'finance', component: FinanceComponent },
  { path: 'viewsupportter', component: ViewsupportterComponent },
  { path: 'test', component: TestComponent },
  { path: 'editplot', component: EditplotComponent },
  { path: 'auditList', component: AuditListComponent },
  { path: 'getfert3', component: GetFert3Component },
  { path: 'editplotmanager', component: EditplotManagerComponent },
  { path: 'editplotpart', component: EditplotPartComponent },
  { path: 'editplotpartform/:itid/:edit_id', component: EditplotPartFormComponent },
  { path: 'emp', component: EmployeeComponent },
  { path: 'map', component: CpMapComponent },
  { path: 'InforQcard', component: InforQcardComponent },
  { path: 'Dps-Edit', component: DpsEditComponent },

  { path: 'oilpay', component: OilpayComponent },
  { path: 'carcut-report', component: CarcutReportComponent },
  { path: 'DismanAreaLv', component: ReportDismanAreaLvComponent },
  { path: 'SumDataCut', component: SumDataCutComponent },
  { path: 'farmer_dev_sys', component: FarmerDevSysComponent },
  { path: 'FinanceOfdata', component: FinanceOfdataComponent },
  { path: 'FileExcel', component: FileExcelComponent },
  { path: 'move-on-q', component: MoveOnQComponent },
  { path: 'FinanceList', component: FinanceListComponent },
  { path: 'FarmerAssess', component: FarmerAssessmentComponent },
  { path: 'ListKpi', component: ListKpiComponent },
  { path: 'Kpi-Zone', component: ListKpiZoneComponent },

  { path: 'OkayGetFert3', component: OkayGetFert3Component },
  { path: 'For-Test', component: ForTestComponent },
  { path: 'Kml-Gene', component: KmlGeneratorComponent },
  { path: 'News', component: NewsComponent },
  { path: 'News_Edit', component: NewsEditComponent },

  { path: 'Upfile', component: UpfileComponent },
  { path: 'new-inform', component: NewInformComponent },
  { path: 'CaneYard', component: CaneYardComponent },
  { path: 'FileFinance', component: FileFinanceComponent },
  { path: 'dashboard_cutF', component: DashboardCutFComponent },
  { path: 'dashboard_growedY', component: DashboardGrowedFComponent },
  { path: 'print_cutF', component: PrintReportCutFComponent },
  { path: 'print_farmers', component: PrintFarmersComponent },

  { path: 'Sidebar2', component: Sidebar2Component },
  { path: 'brdproject', component: BrdprojectComponent },
  { path: 'project_Mem', component: ProjectMemberComponent },
  { path: 'follow-work', component: FollowWorkComponent },
  { path: 'edit-getfactor', component: EditGetfactorComponent },
  { path: 'map_groupcode', component: MapGroupcodeComponent },

  // KTD
  { path: 'brd-diaryCPC', component: BrdDiaryCPCComponent },
  { path: 'supervis-diaryCPC', component: SupervisDiaryCpcComponent },
  { path: 'sugarcane-quality', component: SugarcaneQualityComponent },
  { path: 'canequality', component: CanequalityComponent },
  { path: 'brdcpcForm', component: BrdCpcFormComponent },
  { path: 'brd-diaryCPC', component: BrdDiaryCPCComponent },
  { path: 'supervis-diaryCPC', component: SupervisDiaryCpcComponent },
  { path: 'sugarcane-quality', component: SugarcaneQualityComponent },

  //{ path: 'Callback', component: CallbackComponent },
  //{ path: '**', redirectTo: '/', pathMatch: 'full' }
  //{ path: 'Dps-Detail', component: DpsDetailComponent },
  //{ path: 'Dps-List', component: DpsListComponent },
  // { path: 'supporter', loadChildren: './app.module#AppModule' },
  { path: '**', redirectTo: 'login', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: true,
    anchorScrolling: "enabled",
    onSameUrlNavigation: 'reload',
    scrollPositionRestoration: "enabled",
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
